<script setup>
import { computed } from 'vue';
import ImagePreview from '@/components/create/ImagePreview.vue';
import MaterialPreview from '@/components/create/MaterialPreview.vue';
import DocumentTag from '@/components/create/attach/DocumentTag.vue';

const props = defineProps({
  image: Object,
  chatState: Object,
});

const emit = defineEmits(['update:image', 'material-remove', 'material-update']);

const imagePreview = computed({
  get: () => props.image,
  set: (v) => {
    emit('update:image', v);
  },
});

const removeAsset = (asset) => emit('material-remove', asset);
const updateAsset = (id, tag) => emit('material-update', id, tag);

const display = computed(() => {
  const chatState = props.chatState;
  return (
    imagePreview.value ||
    (chatState.assets && chatState.assets.length) ||
    (chatState.documents && chatState.documents.length)
  );
});

const removeImage = () => {
  imagePreview.value = null;
};

const removeDocument = (asset) => {
  props.chatState.documents = props.chatState.documents.filter((item) => item.id !== asset.id);
};
</script>

<template>
  <div class="flex gap-2 pt-3 px-3 rounded-t-[20px] bg-transparent" v-if="display">
    <div class="shrink-0" v-if="imagePreview">
      <ImagePreview :image="imagePreview" @remove="removeImage" />
    </div>
    <div class="flex gap-2 shrink-0" v-if="chatState.documents && chatState.documents.length">
      <DocumentTag
        v-for="doc in chatState.documents"
        :key="`${doc.id}_${doc.parsed}`"
        :asset="doc"
        @remove="removeDocument"
      />
    </div>
    <MaterialPreview
      v-if="chatState.assets && chatState.assets.length"
      :assets="chatState.assets"
      @remove="removeAsset"
      @update="updateAsset"
    />
  </div>
</template>
